import { css } from '@emotion/css';
import type { TooltipProps } from '@mantine/core';

export const tooltipCardProps = {
  color: 'white',
  c: 'dark',
  radius: 12,
  withArrow: false,
  classNames: {
    tooltip: css`
      padding: var(--mantine-spacing-space3);
      border: 1px solid var(--mantine-color-gray-2);
      box-shadow: 0 12px 28px rgba(32, 10, 66, 0.14);
    `,
  },
} satisfies Partial<TooltipProps>;
